import React from 'react';
import { ChevronUpIcon, ShoppingBagIcon } from 'lucide-react';
const FREE_DELIVERY_THRESHOLD = 55;
interface NowStickyCartProps {
  itemCount: number;
  total: number;
  onViewCart: () => void;
}
export function NowStickyCart({
  itemCount,
  total,
  onViewCart
}: NowStickyCartProps) {
  const amountRemaining = Math.max(0, FREE_DELIVERY_THRESHOLD - total);
  const progress = Math.min(100, total / FREE_DELIVERY_THRESHOLD * 100);
  const itemLabel = itemCount === 1 ? 'item' : 'items';
  const deliveryMessage = amountRemaining > 0 ? `Add SAR ${amountRemaining.toFixed(0)} for free delivery` : 'You unlocked free delivery';
  return <aside className="fixed bottom-16 left-0 right-0 z-40 border-t border-[#d7dfeb] bg-white/95 px-4 pb-3 pt-2 backdrop-blur-sm md:hidden" data-id="element-4566" data-mp="x5pc66ee3t5i">
      <div className="mb-2 rounded-lg bg-[#eaf6ff] px-3 py-2" data-id="element-4567" data-mp="4ntq6bs78tzg">
        <div className="flex items-center justify-between gap-2 text-xs font-semibold text-[#1c5d98]" data-id="element-4568" data-mp="4m0mn5cvupvo">
          <span data-id="element-4569" data-mp="lzy2rw2kyaw">{deliveryMessage}</span>
          <ChevronUpIcon className="h-4 w-4 flex-shrink-0" data-id="element-4570" data-mp="ec6dqx8d5m4u" />
        </div>
        <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-[#c9e3f8]" aria-hidden="true" data-id="element-4571" data-mp="e9sioodoo9xa">
          <div className="h-full rounded-full bg-[#3286c9] transition-[width] duration-200" style={{
          width: `${progress}%`
        }} data-id="element-4572" data-mp="j8dbi2qlvrbp" />
        </div>
      </div>
      <button type="button" onClick={onViewCart} className="flex h-11 w-full items-center justify-between gap-3 rounded-lg bg-[#103d91] px-4 text-left text-white transition-colors duration-150 active:bg-[#0b2d6d]" aria-label={`View cart with ${itemCount} ${itemLabel}, total ${total.toFixed(2)} SAR`} data-id="element-4573" data-mp="szhr94o3vg7l">
        <span className="flex min-w-0 items-center gap-2" data-id="element-4574" data-mp="5a5ig5woxa5t">
          <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-white/15" data-id="element-4575" data-mp="a9rw2ggfksf5"><ShoppingBagIcon className="h-4 w-4" data-id="element-4576" data-mp="1gq3tugfcc8a7" /></span>
          <span className="truncate text-sm font-semibold" data-id="element-4577" data-mp="1gplp0vem4lqo">{itemCount} {itemLabel}</span>
          <span className="h-4 w-px bg-white/30" aria-hidden="true" data-id="element-4578" data-mp="1lnvkz885vqdc" />
          <span className="text-sm font-bold" data-id="element-4579" data-mp="3hrtlhvhpd88o">SAR {total.toFixed(2)}</span>
        </span>
        <span className="flex-shrink-0 text-sm font-bold" data-id="element-4580" data-mp="3ctibnkreqxqg">View cart</span>
      </button>
    </aside>;
}